import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22cc7b03"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-wrapper" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "#"),
    /*#__PURE__*/_createElementVNode("li", null, "Source"),
    /*#__PURE__*/_createElementVNode("li"),
    /*#__PURE__*/_createElementVNode("li", { class: "action" }, "Actions")
  ])
], -1 /* HOISTED */))
const _hoisted_3 = { class: "content-wrapper-outbound" }
const _hoisted_4 = {
  key: 1,
  class: "no-content-wrapper"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "No any outbound templates.", -1 /* HOISTED */))
const _hoisted_6 = { class: "create-template-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditPen = _resolveComponent("EditPen")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    ($data.items.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item, index) => {
              return (_openBlock(), _createElementBlock("ul", { key: index }, [
                _createElementVNode("li", null, _toDisplayString(index+1), 1 /* TEXT */),
                _createElementVNode("li", null, _toDisplayString(item.source), 1 /* TEXT */),
                _createElementVNode("li", null, _toDisplayString(item.name), 1 /* TEXT */),
                _createElementVNode("li", null, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: ($event: any) => ($options.handleEdit(item))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EditPen)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "danger",
                    onClick: ($event: any) => ($options.handleDelete(item.id))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Delete)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/catalog/mapping-template/outbound/create/channel_advisor",
              class: "ec-btn ec-btn-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Create Template")
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]))
  ])), [
    [_directive_loading, $data.loading]
  ])
}